import React from "react";
import { motion } from "framer-motion";
import { FaChurch, FaUtensils, FaMusic } from "react-icons/fa";
import "./Schedule.css";

const Schedule = () => {
  const scheduleItems = [
    {
      time: "12:30",
      title: "Bryllup i Åsane gamle kirke",
      description: "Vielse i den historiske Åsane gamle kirke fra 1795",
      location: "Åsane gamle kirke, Saurås i Åsane",
      icon: FaChurch,
    },
    {
      time: "15:30",
      title: "Velkomstdrink",
      description: "Velkomstdrink og mingling på Musikkhallen",
      location: "Musikkhallen på Holme, Melandsvegen 50, Frekhaug",
      icon: FaUtensils,
    },
    {
      time: "16:00",
      title: "Middag",
      description: "Middag og feiring på Musikkhallen",
      location: "Musikkhallen på Holme, Melandsvegen 50, Frekhaug",
      icon: FaUtensils,
    },
    {
      time: "19:00",
      title: "Kaker og dans",
      description: "Kaker og dans på Musikkhallen",
      location: "Musikkhallen på Holme",
      icon: FaMusic,
    },
  ];

  return (
    <section id="schedule" className="schedule section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Bryllupsprogram
        </motion.h2>

        <div className="timeline">
          {scheduleItems.map((item, index) => (
            <motion.div
              key={index}
              className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
            >
              <div className="timeline-time">{item.time}</div>
              <div className="timeline-content">
                <div className="timeline-icon">
                  <item.icon />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <p className="timeline-location">
                  <item.icon />
                  {item.location}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Schedule;
